import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement } from "react";
import {
	KnowledgeItemCommentNotificationDataViewModel,
	KnowledgeItemCommentReactionNotificationDataViewModel,
	KnowledgeItemCommentMentionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type KnowledgeItemCommentActivityInvocationProps = {
	data: KnowledgeItemCommentNotificationDataViewModel
		| KnowledgeItemCommentReactionNotificationDataViewModel
		| KnowledgeItemCommentMentionNotificationDataViewModel;
	onDismiss: () => void;
};

export const KnowledgeItemCommentActivityInvocation = (props: KnowledgeItemCommentActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		knowledgeItemId,
		commentId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.KnowledgeItem}
			id={knowledgeItemId}
			commentId={commentId}
			onClose={onDismiss}
		/>
	);
};

KnowledgeItemCommentActivityInvocation.displayName = "KnowledgeItemCommentActivityInvocation";
